module.exports = __webpack_public_path__ + "media/images/logo-86be3b16ce91d7f3588593dbb4a053db.svg";